import localStorage from '@/storage/localStorage'
export const getPosition = {
  methods: {
    // 高德地图
    initGdMap () {
      let vm = this
      const AMap = AMap || window.AMap
      AMap.plugin('AMap.Geolocation', function () {
        let geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位，默认:true
          timeout: 10000 // 超过10秒后停止定位，默认：5s
        })
        geolocation.getCurrentPosition(function (status, result) {
          if (status === 'complete') {
            // 获得成功
            let position = {
              lng: result.position.lng,
              lat: result.position.lat,
              address: {
                province: result.addressComponent.province,
                city: result.addressComponent.city,
                district: result.addressComponent.district,
                street: result.addressComponent.street,
                streetNumber: result.addressComponent.streetNumber
              }
            }
            console.log('高德定位成功')
            vm.$store.commit('SET_POSITION', position)
            localStorage.set('position', JSON.stringify(position))
          } else {
            console.log('高德定位失败')
            vm.initBdMap()
          }
        })
      })
    },
    // 百度地图
    initBdMap(){
      let vm = this
      let geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(function(r){
        if(this.getStatus() === BMAP_STATUS_SUCCESS){
          // 获得成功
          let position = {
            lng: r.point.lng,
            lat: r.point.lat,
            address: {
              province: r.address.province,
              city: r.address.city,
              district: r.address.district,
              street: r.address.street,
              streetNumber: r.address.street_number
            }
          }
          console.log('百度定位成功')
          vm.$store.commit('SET_POSITION', position)
          localStorage.set('position', JSON.stringify(position))
        } else {
          console.log('百度定位失败')
        }
      })
    }
  },
  beforeMount () {
    let position = JSON.parse(localStorage.read('position'))
    if(position && position.lng && position.lat){
      this.$store.commit('SET_POSITION', position)
    } else {
      this.initGdMap()
    }
  }
}
